
export enum sortTypes {
    asc = 'asc',
    desc = 'desc'
}


export type sortBy = Array<string>;
export type sortType = sortTypes.asc | sortTypes.desc | null;


export interface TablePaginatedFilters {
    page_size?: number,
    query?: string,
    page?: number,
    sort_by?: sortBy,
    sort_type?: sortType,
}

export interface ClaimTableFilters extends TablePaginatedFilters {
    event_type?: number,
    start_date?: string,
    end_date?: string,
    event_date_from?: string,
    event_date_to?: string,
    area?: string,
    appraisers?: string
}